import { useState } from 'react'

import { useDeleteSavedFilterMutation } from '@/graphql/generated/hooks'

import { SavedFilterI } from '../types/generic'

export const useDeleteFilter = () => {
  const [filter, setFilter] = useState<SavedFilterI>(null)
  const [deleteSavedFilter, { loading: isDeleteLoading }] =
    useDeleteSavedFilterMutation()

  // Plain state instead of Chakra v1 useDisclosure so the rebrand fork can
  // share this hook without a Chakra V1 dependency.
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const onDeleteModalClose = () => setIsDeleteModalOpen(false)

  const onConfirmFilterDelete = (filter: SavedFilterI) => {
    setFilter(filter)
    setIsDeleteModalOpen(true)
  }

  const deleteFilter = async () => {
    await deleteSavedFilter({
      variables: {
        input: {
          id: filter.id,
        },
      },
      refetchQueries: ['SavedIncidentsFilters', 'ActiveIncidentsFilter'],
    })
    onDeleteModalClose()
  }

  return {
    filter,
    deleteFilter,
    isDeleteLoading,
    isDeleteModalOpen,
    onConfirmFilterDelete,
    onDeleteModalClose,
  }
}
